import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pause",
  "use": "pause-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"pause\">\n  <path fill=\"currentColor\" d=\"M23 14h6v16h-6zM15 14h6v16h-6z\" />\n  <path d=\"M25 16h2v12h-2zM17 16h2v12h-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol